import React from 'react'
import './hover-dropdown.style.scss'
export default function HoverDropdown({title,selected,message, list}) {
    return (
        <div className="t-dropdown">
              <p className="td-title">{title}:</p>
              <div className="td-wrapper">
                <div className="tdw-selected">
                  <span>{selected?.name || message}</span>
                  <img src="https://img.icons8.com/material/24/666666/sort-down--v1.png" />
                </div>
                <div className="tdw-drop-list"></div>
              </div>
            </div>
    )
}
